import api from '@/utils/api';

/**
 * Create Product Category
 * @param {string} companyId - the companyId
 * @param {object} categoryData - The category data
 * @returns {Promise}
 */
const createProductCategoryApi = (companyId, categoryData) =>
  api.post(`/company/${companyId}/product-category`, categoryData);

export default createProductCategoryApi;
